module.exports = __webpack_public_path__ + "static/img/main-top.ed99c170.png";